import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { fromRouterActions } from '@amfam/shared/utility/navigation/lib/+state/router-actions';

import { getWorkflowState } from '../store/';
import { workflowStepSetActive } from '../store/workflow/workflow.actions';
import { stepNames } from '../store/workflow/workflow.model';

@Injectable()
export class WorkflowGuardService {
  private store = inject(Store);

  /**
   * This method checks if a step can be activated
   */
  canActivateStep(activeStepName: string, enrollmentType: string | undefined): Observable<boolean> {
    return this.store.select(getWorkflowState).pipe(
      map(workflow => {
        // is workflow loaded?
        if (!workflow.loaded) {
          // entered directly to this step, go to the beginning
          this.store.dispatch(
            fromRouterActions.Go({
              path: ['/enroll/' + enrollmentType]
            })
          );
          return false;
        }
        // is this the active step?
        if (workflow.steps[stepNames.verification]?.name === workflow.activeStep) {
          return true;
        }
        // is this step complete?
        if (workflow.steps[stepNames.verification]?.complete) {
          // workflow does not know we are this step, (could be from back button) set as active step
          // TODO: should the workflow steps specify which steps can be accessed by back button?
          this.store.dispatch(workflowStepSetActive({ activeStep: activeStepName }));
        }
        return false;
      }),
      catchError(_err => of(false))
    );
  }
}
